import { useTranslation } from 'react-i18next';
import { ClbIcon } from '@celebration/react/ClbIcon/ClbIcon';
import LanguageContext from '../../../../../app/contexts/language';
import { formatCurrency } from '../../../../../utils/currency-utils';
import ILoadCardInfo from '../../../../interfaces/loads/ILoadCardInfo';
import ILoadCardDetailInfo from '../../interfaces/ILoadCardDetailInfo';

type RatesProps =
    | { load: ILoadCardInfo; isPool?: false }
    | { load: ILoadCardDetailInfo; isPool: true };

function Rates({ load, isPool }: Readonly<RatesProps>) {
    const { t } = useTranslation();
    const { language } = LanguageContext.useLanguage();

    const renderPoolRates = () => {
        if (!isPool) {
            return null;
        }

        const ratesByVehicle = load.ratesByVehicle ?? [];

        return ratesByVehicle.length > 0 ? (
            ratesByVehicle.map((rate, index) => (
                <div
                    key={rate.vehicle.id}
                    className="rate-details-rates"
                    data-testid={`rate-details-${rate.vehicle.id}`}
                >
                    <span className="rate-rank">{`${index + 1}. `}</span>
                    {rate.vehicle.description}
                    <span
                        data-testid={`rate-details-${rate.vehicle.id}-charge-amount`}
                    >
                        {formatCurrency(
                            rate.chargeAmount,
                            load.shipment.currency,
                            language,
                        )}
                    </span>
                </div>
            ))
        ) : (
            <span
                className="rate-details-no-rates"
                data-testid="rate-details-no-rates"
            >
                <ClbIcon icon="info" size="md" />
                <b>{t('Loads.LoadWithoutRatesReason')}</b>
            </span>
        );
    };

    const renderRates = () => {
        if (isPool) {
            return null;
        }

        return load.rates.length > 0 ? (
            load.rates.map((rate, index) => (
                <div
                    key={rate.code}
                    className="rate-details-rates"
                    data-testid={`rate-details-${rate.code}`}
                >
                    <span className="rate-rank">{`${index + 1}. `}</span>
                    {`[${rate.rateCarrierCode}] ${t(rate.corporateName)} | ${
                        rate.vehicle.description
                    }`}
                    <span
                        data-testid={`rate-details-${rate.code}-charge-amount`}
                    >
                        {formatCurrency(
                            rate.chargeAmount,
                            load.shipment.currency,
                            language,
                        )}
                    </span>
                </div>
            ))
        ) : (
            <span
                className="rate-details-no-rates"
                data-testid="rate-details-no-rates"
            >
                <ClbIcon icon="info" size="md" />
                <b>{t('Loads.LoadWithoutRatesReason')}</b>
            </span>
        );
    };

    return (
        <div className="card-detail-rates__container">
            <div className="card-detail-rates__body">
                <h2>{t('Loads.Rates')}</h2>

                <hr />

                <div className="card-detail-rates__list-container">
                    <div className="card-detail-rates__list">
                        {isPool ? renderPoolRates() : renderRates()}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Rates;
